// import axios from "axios";
import secure_axios from "../../services/secure_axios";
const initialState = ()=>( {
  allcontacts: [],
  thiscontact: {},
  contacttypes: [],
});

const state = initialState();

const getters = {
  allcontacts: (state) => state.allcontacts,
  thiscontact: (state) => state.thiscontact,
  contacttypes: (state) => state.contacttypes,
};

const mutations = {
  setAllContacts(state, payload) {
    state.allcontacts = payload;
  },
  clearContacts(state) {
    state.allcontacts = [];
  },
  setThisContact(state, payload) {
    state.thiscontact = payload;
  },
  setContactTypes(state, payload) {
    state.contacttypes = payload;
  },
  RESET_STATE(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
};

const actions = {
  getAllContacts({ commit, getters }, payload) {
    commit("setLoading", true);
    commit("clearError");

    const accondoctype = payload.accondoctype;
    const accondocno = payload.accondocno;

    secure_axios
      .get(
        `${getters.sessionAPI}contacts?accondoctype=${accondoctype}&accondocno=${accondocno}`
      )
      .then((response) => {
        commit("setAllContacts", response.data.contacts);
        commit("setLoading", false);
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },

  clearAllContacts({ commit }) {
    commit("clearContacts");
  },

  selectThisContact({ commit }, payload) {
    commit("setThisContact", payload);
  },

  getContactTypes({ commit, getters }) {
    secure_axios
      .get(getters.sessionAPI + "contacttypes")
      .then((response) =>
        commit("setContactTypes", response.data.contacttypes)
      );
  },
};

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
};
